module.exports = __webpack_public_path__ + "img/img36.30a308d8.svg";